<template>
  <div class="personal">
    <Nav />
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
          <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <el-breadcrumb class="daohang" separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>
                <span>我的位置</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/personalc?id=0&tab=0' }">我的信息</el-breadcrumb-item>
              <el-breadcrumb-item><a>提现</a></el-breadcrumb-item>
            </el-breadcrumb>

          </div>
          <el-divider></el-divider>
          <div class="title_box">
            <span class="lines"></span>
            <span>提现</span>
          </div>
          <div class="personal-bottom-bottom-right-bottom">
            <div class="content_item">
              <div class="my_Name">我的收益</div>
              <div class="price">
                <span>{{ earningsData.income }}&ensp;&ensp;元</span>
              </div>
            </div>
            <div class="content_item">
              <div class="my_Name">提成比例</div>
              <div class="price">{{ earningsData.percent }}%</div>
              <div class="altermsg">去商城，购买增收卡可提升收益哦～</div>
            </div>
            <div class="content_item_max">
              <div class="big_tittle">提现方式</div>
              <el-collapse class="bgpays" v-model="activeName2" accordion>
                <el-collapse-item name="1">
                  <template v-if="activeName2 == 1" slot="title">
                    <div class="my_user_pay">
                      <img src="https://oss.ansongqiubo.com/assets/personimage/xuanze2.png" alt="" />&nbsp;&nbsp;支付宝
                    </div>
                  </template>
                  <template v-else slot="title">
                    <div class="my_user_pay">
                      <img src="https://oss.ansongqiubo.com/assets/personimage/xuanze1.png" alt="" />&nbsp;&nbsp;支付宝·
                    </div>
                  </template>
                  <div class="my_user_pay">
                    <div class="p_item">
                      <div class="title">姓名</div>
                      <input maxlength="28" v-model="name" placeholder="请输入姓名" type="text" />
                    </div>
                    <div class="p_item">
                      <div class="title">支付宝账号</div>
                      <input maxlength="28" v-model="zhifubao" placeholder="请输入支付宝账号" type="text" />
                    </div>
                    <div class="p_item">
                      <div class="title">手机号</div>
                      <input maxlength="28"  v-model="mobile" placeholder="请输入手机号" type="text" />
                    </div>
                    <div class="p_item">
                      <div class="title">提现金额</div>
                      <input maxlength="28"  v-model="money" placeholder="请输入提现金额" type="text" />
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="2">
                  <template v-if="activeName2 == 2" slot="title">
                    <div class="my_user_pay">
                      <img src="https://oss.ansongqiubo.com/assets/personimage/xuanze2.png" alt="" />&nbsp;&nbsp;银行卡
                    </div>
                  </template>
                  <template v-else slot="title">
                    <div class="my_user_pay">
                      <img src="https://oss.ansongqiubo.com/assets/personimage/xuanze1.png" alt="" />&nbsp;&nbsp;银行卡
                    </div>
                  </template>
                  <div class="my_user_pay">
                    <div class="p_item">
                      <div class="title">姓名</div>
                      <input maxlength="28"  v-model="name" placeholder="请输入姓名" type="text" />
                    </div>
                    <div class="p_item">
                      <div class="title">银行卡号</div>
                      <input maxlength="28"  v-model="bankCardNum" placeholder="请输入银行卡号" type="text" />
                    </div>
                    <div class="p_item">
                      <div class="title">银行卡开户行</div>
                      <input maxlength="28"  v-model="bankName" placeholder="请输入银行卡开户行" type="text" />
                    </div>
                    <div class="p_item">
                      <div class="title">银行卡支行名</div>
                      <input maxlength="28"  v-model="bankSubName" placeholder="请输入银行卡支行名" type="text" />
                    </div>
                    <div class="p_item">
                      <div class="title">提现金额</div>
                      <input maxlength="28"  v-model="money" placeholder="请输入提现金额" type="text" />
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
            <div class="alert_msg">
              <div>注:</div>
              <div>*收益大概3-7个工作日到账</div>
              <div>
                *请您如实准确填写银行卡信息，若信息填写错误，将会导致转账失败
              </div>
            </div>
            <div @click="Tijiao" v-if="activeName2 == 1" :class="earningsData.income<=0?'Mygrays':''"  style="
                margin: 0 auto;
                margin-top: 100px;
                cursor: pointer;
                font-weight: 400;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                width: 176px;
                height: 40px;
                background: #721edc;
                border-radius: 4px;
              ">
              提现
            </div>
            <div @click="Tijiao2" v-if="activeName2 == 2" :class="earningsData.income<=0?'Mygrays':''" style="
                margin: 0 auto;
                margin-top: 100px;
                font-weight: 400;
                cursor: pointer;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                width: 176px;
                height: 40px;
                background: #721edc;
                border-radius: 4px;
              ">
              提现
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="tishi1" style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      ">
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="" />
      <div style="margin-top: 20px">{{ tishi }}</div>
    </div>
    <div v-show="tishi2" style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      ">
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/personimage/tijiao.png" alt="" />
      <div style="margin-top: 20px">提现成功</div>
    </div>
  </div>
</template>

<script>
  import Nav from "../component/Nav.vue";
  import slide from './template_slide.vue'
  import qs from "qs";
  export default {
    name: "App",
    data() {
      return {
        b: 2,
        tishi: false,
        token:'',
        activeName2: "1",
        earningsData: [],
        name: "", //提现姓名
        zhifubao: "", //支付宝账号
        mobile: "", //手机号
        money: "", //提现金额
        bankCardNum: "", //银行卡号
        bankName: "", //银行卡开户行
        bankSubName: "", //银行卡支行名
        tishi: "", //支付宝提示语
        tishi1: false, //提示框
        tishi2: false, //提示框2
        activeName: 2,
      };
    },
    mounted() {
      this.token =  localStorage.getItem("token");
      this.Info();
    },
    methods: {
      //   获取龙币余额和提现余额
      changeSlide(data) {
        this.$router.push(data);
      },
      Info() {
        this.$axios({
          url: this.api + "/v1/wallet/info",
          method: "GET",
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": this.token,
            "Content-Type": "application/json",
          },
        }).then((res) => {
          console.log(res);
          this.earningsData = res.data.data;
        });
      },
      dianji(e) {
        this.b = e;
      },
      ruleQuery(type){
        // if(this.earningsData.income <=0){
        //   this.aletMsg('收益金额不满足提现')
        //   return false
        // }
        if(this.activeName2 == 2){
          if(!this.name){
            this.aletMsg('姓名不能为空')
            return false
          }
          if(!this.bankCardNum){
            this.aletMsg('银行卡号不能为空')
            return false
          }
          if(!this.bankName){
            this.aletMsg('银行卡开户行不能为空')
            return false
          }
          if(!this.name){
            this.aletMsg('姓名不能为空')
            return false
          }
          if(!this.money || this.money <=0){
            this.aletMsg('金额不能为空')
            return false
          }
          if(!this.name){
            this.aletMsg('姓名不能为空')
            return false
          }
          return true
        }else{
          if(!this.name){
            this.aletMsg('姓名不能为空')
            return false
          }
          if(!this.zhifubao){
            this.aletMsg('支付宝账号不能为空')
            return false
          }
          if(!this.mobile){
            this.aletMsg('手机号不能为空')
            return false
          }
          if(!this.money || this.money <=0){
            this.aletMsg('金额不能为空')
            return false
          }
          return true
        }
      },
      aletMsg(val){
        this.tishi =val;
        this.tishi1 = true;
        setTimeout(() => {
          this.tishi1 = false;
        }, 2000);
      },
      // 支付宝提现
      Tijiao() {
        let state = this.ruleQuery();
        if(!state){
          return
        }
        if( this.token){
        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken":this.token,
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function(data) {
              //在请求之前对data传参进行格式转换
              data = qs.stringify(data);
              //   console.log(data);
              return data;
            },
          ],
          url: this.api + "/v1/wallet/withdraw",
          method: "post",
          data: {
            amount: this.money,
            realName: this.name,
            withDrawType: 1,
            alipayAccount: this.zhifubao,
            mobile: this.mobile,
          },
        }).then((res) => {
          // console.log(res);
          if (res.data.message == "success") {
            this.tishi2 = true;
            setTimeout(() => {
              this.tishi2 = false;
              this.Info();
            }, 2000);
          } else {
            this.aletMsg( res.data.message)
          }
        });
        }else{
          this.$message.error('登录后重试')
        }
      },
      // 银行卡提现
      Tijiao2() {
        let state = this.ruleQuery();
        if(!state){
          return
        }
        if( this.token){
          this.$axios({
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": localStorage.getItem("token"),
              "Content-Type": "application/x-www-form-urlencoded",
            },
            transformRequest: [
              function(data) {
                //在请求之前对data传参进行格式转换
                data = qs.stringify(data);
                //   console.log(data);
                return data;
              },
            ],
            url: this.api + "/v1/wallet/withdraw",
            method: "post",
            data: {
              amount: this.money,
              realName: this.name,
              withDrawType: 2,
              bankCardNum: this.bankCardNum,
              bankName: this.bankName,
              bankSubName: this.bankSubName,
            },
          }).then((res) => {
            // console.log(res);
            if (res.data.message == "success") {
              this.tishi2 = true;
              setTimeout(() => {
                this.tishi2 = false;
                this.Info();
              }, 2000);
            } else {
              this.aletMsg(res.data.message)
            }
          });
        }else{
          this.$message.error('登录后重试')
        }

      },
    },
    components: {
      Nav,
      slide
    },
  };
</script>
<style>
  .content_item_max .el-collapse-item__header {
    background: #f7f8fa !important;

  }

  .content_item_max .el-collapse-item__wrap {
    background: #f7f8fa !important;

  }
</style>
<style scoped lang='scss'>
  .a {
    background-color: #721edc;
  }
  .Mygrays{
    background-color:#666 !important;
  }

  .personal-bottom-bottom-left .el-collapse-item__header {
    box-sizing: border-box;
    padding-left: 20px;
    background-color: #fff;
    border-bottom: 0px solid #ebeef5;
    color: #333;
  }

  .personal-bottom-bottom-right .el-collapse-item__header {
    background: #f7f8fa !important;
  }

  .el-collapse-item__wrap {
    background-color: #f7f8fa !important;
  }

  .personal-bottom-bottom-left .is-active {
    color: rgba(114, 30, 220, 1);
  }

  .personal-bottom-bottom-left .el-collapse-item__content {
    padding-bottom: 0px;
  }

  .personal-bottom-bottom-left .el-collapse-item__wrap {
    border-bottom: 0px solid #ebeef5;
  }

  .personal-bottom-bottom-left .el-collapse-item__content>div {
    text-align: center;
  }

  .personal-bottom-bottom-left .el-collapse {
    width: 100%;
    background: #f7f8fa;
  }

  .personal-bottom-bottom-left .el-collapse-item__wrap {
    background: #f7f8fa;
    color: #333;
  }

  .personal {
    width: 100vw;
    background: #f7f8fa;

    .title_box {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .lines {
        display: inline-block;
        width: 4px;
        margin-right: 6px;
        border-radius: 4px;
        height: 20px;
        background: #721edc;
      }

      span {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
    }

    .xzcxzcxz {
      color: rgba(114, 30, 220, 1) !important;
    }

    .personal-bottom {
      background-color: #f7f8fa;
    }

    .personal-bottom-top {
      width: 100%;
      height: 60px;
      min-width: 1240px;
      background-color: #fff;
    }

    .personal-bottom-top-div {
      width: 1240px;
      height: 60px;
      margin: 0 auto;
      color: #333;
      font-size: 23px;
      line-height: 60px;
      display: flex;
      align-items: center;
    }

    .personal-bottom-top-div-div {
      width: 6px;
      height: 50px;
      background-color: #721edc;
      border-radius: 6px;
    }
  }

  .personal-bottom-bottom {
    width: 1200px;
    height: calc(100vh - 105px);
    margin: 0 auto;
    display: flex;
    background-color: #f7f8fa;
    min-width: 1200px;

    .personal-bottom-bottom-left {
      width: 190px;
      height: 100%;
      background-color: #fff;
      margin-top: 16px;
      color: #333;

      .myel-collapse-item {
        width: 190px;
      }

      .prent_item {
        text-align: center;
        width: 100%;
        height: 100%;
        display: flex;

        .parent_icon {
          display: flex;
          align-items: center;
        }

        .parent_name {
          display: flex;
          align-items: center;
          font-size: 14px;
        }
      }

      .child_item {
        color: #a6a6a6;
        width: 100%;
        height: 52px;
        line-height: 52px;
        background-color: #f2f2f2;

        .child_img {
          display: flex;
          align-items: center;
        }

        .child_name {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }

  .personal-bottom-bottom-right {
    margin-left: 12px;
    height: 100%;
    max-width: 998px;
    background-color: #fff;
    flex: 2;

    padding: 30px 20px;
    box-sizing: border-box;
    margin-top: 16px;

    .personal-bottom-bottom-right-top {
      background-color: #fff;
      display: flex;
      align-items: center;
    }

    .xinxi {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }

    .xinxi:hover {
      color: #721edc;
    }

    .maxtitle {
      font-size: 20px !important;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600 !important;
      color: #333333;

      span {
        font-weight: 600 !important;
        color: #333333;
      }
    }
  }

  .personal-bottom-bottom-right-bottom {
    height: calc(94% - 15px);
    box-sizing: border-box;
    margin-top: 25px;
    /* padding-top: 15px; */
    /* border-top: 1px solid rgba(0, 0, 0, 0.2); */
    position: relative;
  }

  .alert_msg {
    margin-top: 20px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ed1010;
  }

  .content_item_max {
    display: flex;
    color: #ffffff;
    margin-top: 16px;
    align-items: flex-start;

    .big_tittle {
      min-width: 66px;
      text-align: left;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }

    .el-collapse-item__header {
      box-sizing: border-box;
      padding-left: 20px;
      background-color: #f7f8fa !important;
      border-bottom: 0px solid #ebeef5;
      color: #333;
    }

    .bgpays {
      margin-left: 20px;
    }

    .my_user_pay {
      width: 100%;
      min-width: 240px;
      background: #f7f8fa !important;
      border-radius: 4px;
      padding: 0 8px;

      .p_item {
        display: flex;
        align-items: center;
        margin: 12px;

        .title {
          min-width: 66px;
          text-align: left;

          margin-right: 10px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        input {
          border: none;
          outline-style: none;
          width: 142px;
          padding: 0 10px;
          box-sizing: border-box;
          height: 28px;
          border-radius: 4px;
          text-align: center;
          line-height: 28px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }

  .content_item {
    display: flex;
    color: #ffffff;
    margin-top: 16px;
    align-items: center;

    .my_Name {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }

    .altermsg {
      margin-left: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff8729;
    }

    .price {
      width: 280px;
      height: 36px;
      line-height: 36px;
      background: #f7f8fa;
      border-radius: 4px;
      box-sizing: border-box;
      margin-left: 20px;
      padding-left: 10px;
      border-radius: 4px 6px 6px 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }

  .daohang {
    display: flex;
    color: white;
    width: 500px;
  }

  .xinxi {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }

  .xinxi:hover {
    color: #721edc;
  }

  .biao {
    width: 16px;
    height: 16px;
    background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
  }

  .colorBiao {
    background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
  }
</style>



// WEBPACK FOOTER //
// src/component/Wodeshouyi.vue